import styled from 'styled-components';

//@ts-ignore
import Popover from '@mindtickle/popover';
import { borderTokens } from '@mindtickle/styles';
import { mixins } from '@mindtickle/styles';

export const StyledPopover = styled(Popover)`
  && .mtdls-popover-inner {
    padding: 0;
  }

  .mtdls-popover-arrow {
    display: none;
  }

  .mtdls-popover-content {
    width: 240px;
  }

  .mtdls-popover-inner-content {
    width: unset;
  }

  &.mtdls-popover {
    z-index: ${mixins.zIndex.STATUS_BAR};
  }
`;

export const StyledMenuContent = styled.div`
  display: flex;
  flex-direction: column;

  .menu-content-title {
    padding: 16px 24px;
    border-bottom: 1px solid ${borderTokens.COLOR_BORDER_SECONDARY};
  }

  .menu-content-wrapper {
    display: flex;
    flex-direction: column;
    padding: 8px 16px;
    row-gap: 4px;
  }
`;

export const StyledNavLoaderItem = styled.div`
  height: 32px;
  border-radius: 6px;
  & > div {
    width: 100%;
    height: 100%;
  }
`;

export const loaderStyle = {
  height: '100%',
  width: '100%',
};
